

const Emerald = ({
    SurgeryFormData,
    setSurgeryFormData,
    currentPage,
    pageRefs,
    pageTitles,
    isNext,
    invalidFields,
    handleInputChange,
    handleCheckboxChange,
    verifyDob,
    setVerifyDob,
    signatures,
    setSignatures,
    isEditing,
    toggleEditMode,
    updateSignatureData,
    clearSignature,
    canvasRefs,
    surgeonOptionsMap,
    docSignature,
    logo,
    renderNextButton,
    renderSurgeryUploadButton,
    surgeryUpload,
    formatDate,
    handleMedicationTimeChange,
    getCentralAmericaDate,
    getCentralAmericaTime,
    handleNext,
    Head,
    SignatureField,
    Paragraph,
    FormInput,
    Logo,
    DOBPickerInput,
    SelectInput,
    TimePickerInput,
    TextInput,
    SurgeryInfoDisplay,
    DatePickerInput,
    RadioGroup,
    anesthesiaOptions,
    TextAreaInput,
    MedTimePicker
}) => {
    return (
        <>
            <form className="bg-white">
                {currentPage === 0 && (
                    <div ref={pageRefs.current[currentPage]} className="w-full bg-white px-2 mx-5 py-2">
                        <div className="px-1 mx-8 py-1">

                            <Head title={pageTitles['Emerald Coast Surgery Center'][currentPage]} />

                            <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                {[
                                    {
                                        id: "first_name",
                                        label: "First Name",
                                        required: true,
                                    },
                                    {
                                        id: "last_name",
                                        label: "Last Name",
                                        required: true,
                                    }
                                ].map(({ id, label, required }) => (
                                    <FormInput
                                        key={id}
                                        id={id}
                                        label={label}
                                        type="text"
                                        disabled={isNext}
                                        value={SurgeryFormData[id]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes(id) && !SurgeryFormData[id]}
                                        required={required}
                                    />
                                ))}
                            </div>


                            <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                {/* DOB */}
                                <DOBPickerInput
                                    id="dob"
                                    label="Date of Birth"
                                    value={verifyDob}
                                    onChange={(date) => {
                                        setVerifyDob(date || null);
                                        setSurgeryFormData((prev) => ({
                                            ...prev,
                                            dob: date ? formatDate(date) : "",
                                        }));
                                    }}
                                    disabled={isNext}
                                    required
                                    invalid={invalidFields.includes("dob") && !verifyDob}
                                />

                                {/* Cell Phone */}
                                <SelectInput
                                    id="surgeon"
                                    label="Surgeon"
                                    options={surgeonOptionsMap[localStorage.getItem("digital-form-dept-practice")] || []}
                                    value={SurgeryFormData.surgeon}
                                    onChange={(e) => {
                                        const selectedSignature = docSignature[e.target.value];

                                        setSignatures((prev) => ({
                                            ...prev,
                                            doctor_signature: selectedSignature,
                                        }));

                                        setSurgeryFormData((prev) => ({
                                            ...prev,
                                            doctor_signature: selectedSignature,
                                        }));

                                        setSurgeryFormData((prev) => ({
                                            ...prev,
                                            surgeon: e.target.value,
                                        }));
                                    }}

                                    disabled={isNext}
                                    invalid={invalidFields.includes("Surgeon") && !SurgeryFormData.surgeon}
                                    errorMessage="Please select a surgeon."
                                />
                            </div>


                            <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                <label htmlFor='interpreter' className="flex items-center space-x-2 select-none my-4">
                                    <span className="text-base font-medium text-black">
                                        Does Patient Need an Interpreter?
                                    </span>
                                    <input
                                        type="checkbox"
                                        id='interpreter'
                                        disabled={isNext}
                                        checked={SurgeryFormData.interpreter || false}
                                        onChange={(e) =>
                                            setSurgeryFormData((prev) => ({
                                                ...prev,
                                                interpreter: !SurgeryFormData.interpreter,
                                            }))
                                        }
                                        className="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
                                    />

                                </label>


                                {/* Authorization Contact Number */}
                                <FormInput
                                    key='authorization_number'
                                    id='authorization_number'
                                    label='Authorization#'
                                    type="text"
                                    disabled={isNext}
                                    value={SurgeryFormData['authorization_number']}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes('authorization_number') && !SurgeryFormData['authorization_number']}
                                    required={false}
                                />
                            </div>



                            <div className="mb-4 grid grid-cols-1 sm:grid-cols-3 gap-2">
                                {/* Requested Date of surgery */}
                                <DatePickerInput
                                    id="requested_date_of_surgery"
                                    label="Admit Date"
                                    value={SurgeryFormData.requested_date_of_surgery} // must be Date or null
                                    onChange={(date) =>
                                        setSurgeryFormData((prev) => ({
                                            ...prev,
                                            requested_date_of_surgery: date || null, // store Date object
                                        }))
                                    }
                                    disabled={isNext}
                                    invalid={
                                        invalidFields.includes("requested_date_of_surgery") &&
                                        !SurgeryFormData.requested_date_of_surgery
                                    }
                                    minDate={new Date()}
                                />

                                <TimePickerInput
                                    id="requested_time_of_surgery"
                                    label="Surgery Time"
                                    value={SurgeryFormData.requested_time_of_surgery}
                                    onChange={(date) =>
                                        setSurgeryFormData((prev) => ({
                                            ...prev,
                                            requested_time_of_surgery: date,
                                        }))
                                    }
                                    disabled={isNext}
                                    invalid={
                                        invalidFields.includes("requested_time_of_surgery") &&
                                        !SurgeryFormData.requested_time_of_surgery
                                    }
                                />
                                <FormInput
                                    key='length_of_surgery'
                                    id='length_of_surgery'
                                    label='Estimated Time Needed'
                                    type="text"
                                    disabled={isNext}
                                    value={SurgeryFormData['length_of_surgery']}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes('length_of_surgery') && !SurgeryFormData['length_of_surgery']}
                                    required={true}
                                />

                            </div>


                            <TextInput
                                id="icd10_codes"
                                label="Diagnosis Codes"
                                value={SurgeryFormData.icd10_codes}
                                onChange={handleInputChange}
                                disabled={isNext}
                                invalid={invalidFields.includes("icd10_codes") && !SurgeryFormData.icd10_codes}
                            />

                            <TextInput
                                id="cpt_codes"
                                label="Procedure Codes"
                                value={SurgeryFormData.cpt_codes}
                                onChange={handleInputChange}
                                disabled={isNext}
                                invalid={invalidFields.includes("cpt_codes") && !SurgeryFormData.cpt_codes}
                            />


                            <p className="text-base text-blue-700 leading-relaxed my-4"> Per MD Order </p>

                            <TextInput
                                id="procedure_description"
                                label="Consent To Read"
                                required
                                value={SurgeryFormData.procedure_description}
                                onChange={handleInputChange}
                                disabled={isNext}
                                invalid={invalidFields.includes("procedure_description") && !SurgeryFormData.procedure_description}
                            />

                            {/* Row 9: Anesthesia */}
                            <RadioGroup
                                label="Anesthesia"
                                name="anesthesia"
                                options={anesthesiaOptions}
                                selectedValue={SurgeryFormData.anesthesia}
                                onChange={(value) =>
                                    setSurgeryFormData({
                                        ...SurgeryFormData,
                                        anesthesia: value,
                                    })
                                }
                                disabled={isNext}
                                required
                            />

                            <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">

                                <FormInput
                                    key='block_anesthesiologist'
                                    id='block_anesthesiologist'
                                    label='Block by Anesthesiologist'
                                    type="text"
                                    disabled={isNext}
                                    value={SurgeryFormData['block_anesthesiologist']}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes('block_anesthesiologist') && !SurgeryFormData['block_anesthesiologist']}
                                    required={false}
                                />
                                <FormInput
                                    key='block_surgeon'
                                    id='block_surgeon'
                                    label='Block By Surgeon'
                                    type="text"
                                    disabled={isNext}
                                    value={SurgeryFormData['block_surgeon']}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes('block_surgeon') && !SurgeryFormData['block_surgeon']}
                                    required={false}
                                />
                            </div>

                            <RadioGroup
                                label="Pre-Op Clearance Requested"
                                name="preop_clearance"
                                disabled={isNext}
                                selectedValue={SurgeryFormData.preop_clearance}
                                onChange={(value) =>
                                    setSurgeryFormData({
                                        ...SurgeryFormData,
                                        preop_clearance: value,
                                    })
                                }
                                options={[
                                    { value: true, label: "Yes" },
                                    { value: false, label: "No" },
                                ]}
                            />


                            <Paragraph>Pre-Op Testing Requested: (Pre-Op testing is NOT required by the Center—MD Preference Only)</Paragraph>
                            <div className="flex flex-wrap gap-4">
                                {Object.keys(SurgeryFormData.emerald_labtests).map((test) => (
                                    <div key={test} className="flex items-center space-x-4">
                                        <input
                                            type="checkbox"
                                            name={test}
                                            disabled={isNext}
                                            checked={SurgeryFormData.emerald_labtests[test] === true}
                                            onChange={() => handleCheckboxChange("emerald_labtests", test, !SurgeryFormData.emerald_labtests[test])}
                                            className="form-checkbox font-medium h-5 w-5 text-blue-600 border-gray-300 rounded"
                                        />
                                        <span className="text-black">{test}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
                {
                    currentPage === 1 && (
                        <div ref={pageRefs.current[currentPage]} className="w-full bg-white">
                            <div className="px-1 mx-6 py-2">


                                <p className="text-base text-black leading-relaxed my-4">Pre-Op Orders</p>
                                <div className="flex flex-wrap gap-4">
                                    {Object.keys(SurgeryFormData.emerald_preop_orders).map((order) => (
                                        <div key={order} className="flex items-center space-x-4">
                                            <input
                                                type="checkbox"
                                                disabled={isNext}
                                                name={order}
                                                checked={SurgeryFormData.emerald_preop_orders[order] === true}
                                                onChange={() => handleCheckboxChange("emerald_preop_orders", order, !SurgeryFormData.emerald_preop_orders[order])}
                                                className="form-checkbox font-medium h-5 w-5 text-blue-600 border-gray-300 rounded"
                                            />
                                            <span className="text-black">{order}</span>
                                        </div>
                                    ))}
                                </div>


                                <TextAreaInput
                                    id="additionalorders"
                                    label=""
                                    value={SurgeryFormData.additionalorders}
                                    onChange={handleInputChange}
                                    placeholder="Add additional orders"
                                    disabled={isNext}
                                />

                                <Paragraph>Special Equipment Needs: (Implants/type of hardware to be placed/removed)</Paragraph>
                                <RadioGroup
                                    label="Need Rep here?"
                                    name="vendor_rep"
                                    required={false} // set true if it's required
                                    disabled={isNext}
                                    selectedValue={SurgeryFormData.vendor_rep}
                                    onChange={(value) => {
                                        setSurgeryFormData((prev) => ({
                                            ...prev,
                                            vendor_rep: value,
                                        }));
                                    }}
                                    options={[
                                        { value: true, label: "Yes" },
                                        { value: false, label: "No" },
                                    ]}
                                />
                                {/* Special Equipment */}


                                <TextAreaInput
                                    id="special_equipment"
                                    label=""
                                    value={SurgeryFormData.special_equipment}
                                    onChange={handleInputChange}
                                    placeholder="Enter Special Equipment Needs"
                                    disabled={isNext}
                                />

                                <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    {[
                                        {
                                            id: "rep_name",
                                            label: "Rep Name",
                                            required: false,
                                        },
                                        {
                                            id: "rep_phone",
                                            label: "Phone #",
                                            required: false,
                                        }
                                    ].map(({ id, label, required }) => (
                                        <FormInput
                                            key={id}
                                            id={id}
                                            label={label}
                                            type="text"
                                            disabled={isNext}
                                            value={SurgeryFormData[id]}
                                            onChange={handleInputChange}
                                            invalid={invalidFields.includes(id) && !SurgeryFormData[id]}
                                            required={required}
                                        />
                                    ))}
                                </div>


                                <div className="mb-4 flex flex-col sm:flex-row flex-wrap gap-4 items-center">
                                    <p className="font-roboto text-base text-black whitespace-nowrap">
                                        {SurgeryFormData.surgeon}
                                    </p>
                                    <p className="font-roboto text-base text-black whitespace-nowrap mx-1">
                                        {SurgeryFormData.signedDate}
                                    </p>
                                    <p className="font-roboto text-base text-black whitespace-nowrap">
                                        {SurgeryFormData.signedTime}
                                    </p>
                                    {!isNext && (
                                        <button
                                            type="button"
                                            onClick={() =>
                                                setSurgeryFormData({
                                                    ...SurgeryFormData,
                                                    signedDate: getCentralAmericaDate(),
                                                    signedTime: getCentralAmericaTime(),
                                                })
                                            }
                                            disabled={isNext}
                                            className="p-2 rounded-md bg-blue-600 hover:bg-blue-700 text-white focus:outline-none"
                                            title="Set Central America Date & Time"
                                        >
                                            <i className="fas fa-calendar-days text-white text-lg"></i>
                                        </button>
                                    )}
                                </div>


                                {/* Doctor Signature */}
                                <div className="w-full rounded-lg bg-white">
                                    {/* Signature Label */}
                                    <label className="block text-base font-medium text-black mb-3">Signature Of Practitioner</label>
                                    {/* Signature Canvas */}
                                    <div className="relative">
                                        <div>
                                            <div className="mb-4">
                                                {SurgeryFormData['doctor_signature'] && !isEditing['doctor_signature'] ? ( // Toggle between edit and display mode

                                                    <img
                                                        src={SurgeryFormData['doctor_signature']}
                                                        alt="Signature"
                                                        loading="eager"
                                                        style={{
                                                            width: '300px',
                                                            height: '100px',
                                                            maxWidth: '100%',
                                                            maxHeight: '100%',
                                                            borderRadius: '0.375rem', // same as Tailwind's rounded-md
                                                            border: '1px solid #D1D5DB', // Tailwind's border-gray-300
                                                            objectFit: 'contain',
                                                            display: 'block',
                                                        }}
                                                    />

                                                ) : (
                                                    null
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    )
                }

                {
                    currentPage === 2 && (
                    <div ref={pageRefs.current[currentPage]} className="max-w-4xl w-full bg-white">
                            <div className="px-1 mx-6 py-1">

                                <Logo src={logo} />
                                <Head title={pageTitles['Emerald Coast Surgery Center'][currentPage]} />

                                <div className="mb-4 grid grid-cols-1 gap-4">
                                    <div className="flex items-center">
                                        <Paragraph>Patient Name - {SurgeryFormData.first_name} {SurgeryFormData.last_name}</Paragraph>
                                    </div>
                                </div>

                                <div>
                                    <Paragraph>
                                        You have been given information about your condition and the recommended surgical, medical, or diagnostic procedure(s) to be used. This consent form is designed to provide a written confirmation of such discussions by recording some of the more significant medical information given to you. It is intended to make you better informed so that you may give or withhold your consent to the proposed procedure(s).
                                    </Paragraph>

                                    <h3 className="text-lg font-semibold mb-2">1. Condition:</h3>
                                    <Paragraph>
                                        I have been informed that the following condition(s) exist in my case by doctor: <span className="font-semibold">{SurgeryFormData.surgeon}</span>
                                    </Paragraph>
                                    <TextAreaInput
                                        key="diagnosis"
                                        id="diagnosis"
                                        label="Diagnosis:"
                                        type="text"
                                        disabled={isNext}
                                        value={SurgeryFormData.diagnosis}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes("diagnosis") && !SurgeryFormData.diagnosis}
                                        required={false}
                                    />

                                    <h3 className="text-lg font-semibold mb-2">2. Proposed Procedure(s):</h3>
                                    <Paragraph>
                                        I understand that the procedure(s) for evaluating and treating my condition are:
                                    </Paragraph>

                                    <TextAreaInput
                                        key="procedure_description"
                                        id="procedure_description"
                                        label=""
                                        type="text"
                                        disabled={isNext}
                                        value={SurgeryFormData.procedure_description}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes("procedure_description") && !SurgeryFormData.procedure_description}
                                        required={false}
                                    />


                                    <h3 className="text-lg font-semibold mb-2">3. Risks/Benefits of Proposed Procedure(s):</h3>
                                    <Paragraph >
                                        A. Just as there may be benefits to the procedure(s) proposed, I also understand that medical and surgical procedure involve risks. These risks include allergic reactions, bleeding, blood clots, infections, adverse side effects of drugs, and even loss of bodily function or life, as well as risks of transfusion reactions and the transmission of infectious disease, including Hepatitis and Acquired Immune Deficiency Syndrome from the administration of blood and/or blood components.
                                    </Paragraph>
                                    <Paragraph >
                                        B. I also realize that there are particular risks associated with the procedure(s) proposed for me and that these risks include, but are not limited to:
                                    </Paragraph>
                                    <Paragraph >
                                        <ul className="list-disc list-inside mb-4">
                                            <li>Failure to accomplish the intent of the surgery</li>
                                            <li>Retinal detachment that may require additional surgery or may be inoperable</li>
                                            <li>Hemorrhage</li>
                                            <li>Infection/inflammation</li>
                                            <li>Elevated eye pressure (glaucoma)</li>
                                            <li>Corneal clouding and scarring</li>
                                            <li>Cataract which might require eventual or immediate removal of the lens</li>
                                            <li>Double vision</li>
                                            <li>Eyelid drooping</li>
                                            <li>Loss of circulation to vital tissues in the eye resulting in decreased or loss of vision</li>
                                            <li>Permanent blindness or diminished visual acuity or field</li>
                                            <li>Loss of eye</li>
                                            <li>Pain</li>
                                        </ul>
                                    </Paragraph>
                                    <h3 className="text-lg font-semibold mb-2">4. Complications: Unforeseen Conditions; Results:</h3>
                                    <Paragraph>
                                        I am aware that in the practice of medicine other unexpected risks or complications not discussed may occur. I also understand that during the course of the proposed procedure(s), unforeseen conditions may be revealed requiring the performance of additional procedure, and I authorize such procedure to be performed. I further acknowledge that no guarantees or promises have been made to me concerning the results of any procedure or treatment.
                                    </Paragraph>

                                    <h3 className="text-lg font-semibold mb-2">5. Acknowledgements:</h3>
                                    <Paragraph>
                                        The available alternatives, some of which include: The potential benefits and risks of the proposed procedure(s), and the likely result without such treatment have been explained to me. I understand what has been discussed with me as well as the contents of this consent form and have been given the opportunity to ask questions and have received satisfactory answers.
                                    </Paragraph>
                                </div>
                            </div>
                        </div>
                    )
                }

                {
                    currentPage === 3 && (
                        <div ref={pageRefs.current[currentPage]} className="w-full bg-white">
                            <div className="px-1 mx-8 py-2">
                                <div>
                                    <h3 className="text-lg font-semibold mb-2">Consent to Procedure(s) and Treatment:</h3>
                                    <Paragraph>
                                        Having read this form and talked with the physicians, my signature below acknowledges that I voluntarily give my authorization and consent to the performance of the procedure(s) described above (including the administration of blood and disposal of tissue) by my physician and/or his/her associates assisted by hospital personnel and other trained persons as well as the presence of observers.
                                    </Paragraph>
                                </div>

                                <div className="mb-4 flex flex-wrap gap-2 items-center">
                                    <p className="text-base font-medium text-black whitespace-nowrap">
                                        {SurgeryFormData.first_name}
                                    </p>

                                    <p className="text-base font-medium text-black whitespace-nowrap">
                                        {SurgeryFormData.last_name}
                                    </p>

                                    <p className="text-base font-medium text-black whitespace-nowrap">
                                        {SurgeryFormData.patientSignedDate}
                                    </p>
                                </div>

                                <div>
                                    <div className="mb-4">
                                        <label className="block text-base font-medium text-black mb-3">Patient (or person authorized to sign for patient):</label>

                                        <SignatureField
                                            fieldName="patient_signature"
                                            label=""
                                            formData={SurgeryFormData}
                                            isEditing={isEditing}
                                            isDisabled={isNext}
                                            signatures={signatures}
                                            canvasRefs={canvasRefs}
                                            invalidFields={invalidFields}
                                            updateSignatureData={updateSignatureData}
                                            clearSignature={clearSignature}
                                            toggleEditMode={toggleEditMode}
                                            isNext={isNext}
                                        />
                                    </div>
                                </div>




                                <div className="mb-4 flex flex-wrap gap-2 items-center">
                                    <p className="text-base font-medium text-black whitespace-nowrap">
                                        {SurgeryFormData.surgeon}
                                    </p>

                                    <p className="text-base font-medium text-black whitespace-nowrap">
                                        {SurgeryFormData.signedDate}
                                    </p>
                                </div>

                                {/* Doctor Signature */}
                                <div className="w-full rounded-lg bg-white">
                                    {/* Signature Label */}
                                    <label className="block text-base font-medium text-black mb-3">Signature of Surgeon</label>
                                    {/* Signature Canvas */}
                                    <div className="relative">
                                        <div>
                                            <div className="mb-4">
                                                {SurgeryFormData['doctor_signature'] && !isEditing['doctor_signature'] ? ( // Toggle between edit and display mode
                                                    <img
                                                        src={SurgeryFormData['doctor_signature']}
                                                        alt="Signature"
                                                        loading="eager"
                                                        style={{
                                                            width: '300px',
                                                            height: '100px',
                                                            maxWidth: '100%',
                                                            maxHeight: '100%',
                                                            borderRadius: '0.375rem', // same as Tailwind's rounded-md
                                                            border: '1px solid #D1D5DB', // Tailwind's border-gray-300
                                                            objectFit: 'contain',
                                                            display: 'block',
                                                        }}
                                                    />
                                                ) : (
                                                    null
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
{/* 
                                <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    <FormInput
                                        key='witness_name'
                                        id='witness_name'
                                        label='Witness Name'
                                        type="text"
                                        disabled={isNext}
                                        value={SurgeryFormData['witness_name']}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes('witness_name') && !SurgeryFormData['witness_name']}
                                        required={false}
                                    />
                                </div>

                                <SignatureField
                                    fieldName="witness_signature"
                                    label={`Witness Signature ${SurgeryFormData.witnessSignedDate}`}
                                    formData={SurgeryFormData}
                                    isEditing={isEditing}
                                    isDisabled={isNext}
                                    signatures={signatures}
                                    canvasRefs={canvasRefs}
                                    invalidFields={invalidFields}
                                    updateSignatureData={updateSignatureData}
                                    clearSignature={clearSignature}
                                    toggleEditMode={toggleEditMode}
                                    isNext={isNext}
                                /> */}
                            </div>
                        </div>
                    )
                }
                {
                    currentPage === 4 && (
                        <div ref={pageRefs.current[currentPage]} className="max-w-4xl w-full bg-white">
                            <div className="px-1 mx-6 py-2">

                                <Logo src={logo} />
                                <SurgeryInfoDisplay SurgeryFormData={SurgeryFormData} />

                                {/* Allergies */}

                                <TextInput
                                    id="allergies"
                                    label="Allergies"
                                    value={SurgeryFormData.allergies}
                                    onChange={handleInputChange}
                                    disabled={isNext}
                                    invalid={invalidFields.includes("allergies") && !SurgeryFormData.allergies}
                                />


                                <div className=" bg-white mx-auto">
                                    <label htmlFor="emerald_admission" className="block text-base font-medium text-black col-span-1 mb-2">Admission</label>
                                    {Object.keys(SurgeryFormData.emerald_admission).map((key) => (
                                        <div key={key} className="flex space-x-3 mb-2">
                                            <input
                                                type="checkbox"
                                                id={key}
                                                disabled={isNext}
                                                checked={SurgeryFormData.emerald_admission[key] === true}
                                                onChange={() => handleCheckboxChange("emerald_admission", key, !SurgeryFormData.emerald_admission[key])}
                                                className="form-checkbox h-5 w-5 text-blue-600 border-gray-300 rounded"
                                            />
                                            <label htmlFor={key} className="font-medium text-black">{key}</label>
                                        </div>
                                    ))}
                                </div>

                                <div>
                                    <h2 className="text-lg font-semibold mb-4">Medications</h2>
                                    <div className="grid grid-cols-1 gap-4">
                                        {Object.keys(SurgeryFormData.emerald_medication_times).map((med) => (
                                            <div key={med} className="space-y-2">
                                                <p className="font-semibold text-black">
                                                    {med} one drop in operative eye every 5 minutes times 3 on call to OR Given at
                                                </p>
                                                <div className="grid grid-cols-3 gap-4">
                                                    {SurgeryFormData.emerald_medication_times[med].map((time, index) => (
                                                        <div key={index} className="flex items-center space-x-2 ">
                                                            <MedTimePicker
                                                                value={time}
                                                                onChange={(val) => handleMedicationTimeChange("emerald_medication_times", med, index, val)}
                                                                disabled={isNext}
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <h2 className="text-lg font-semibold">Additional Orders</h2>

                                <TextAreaInput
                                    id="additionalorders"
                                    label=""
                                    value={SurgeryFormData.additionalorders}
                                    onChange={handleInputChange}
                                    placeholder="Add additional orders"
                                    disabled={isNext}
                                />

                                <div className="grid grid-cols-12">
                                    <div className="flex col-span-6">
                                        <div className="w-[75%] mb-2">
                                            <div className="font-semibold flex gap-2 text-black pb-4">
                                                <p className="whitespace-nowrap">{SurgeryFormData.surgeon}</p>
                                                {SurgeryFormData['doctor_signature'] && (

                                                    null
                                                )}

                                            </div>

                                            {SurgeryFormData['doctor_signature'] && !isEditing['doctor_signature'] ? ( // Toggle between edit and display mode

                                                <img
                                                    src={SurgeryFormData['doctor_signature']}
                                                    alt="Signature"
                                                    loading="eager"
                                                    style={{
                                                        width: '300px',
                                                        height: '100px',
                                                        maxWidth: '100%',
                                                        maxHeight: '100%',
                                                        borderRadius: '0.375rem', // same as Tailwind's rounded-md
                                                        border: '1px solid #D1D5DB', // Tailwind's border-gray-300
                                                        objectFit: 'contain',
                                                        display: 'block',
                                                    }}
                                                />

                                            ) : (
                                                null
                                            )}

                                        </div>
                                    </div>
                                    <div className="flex col-span-6">
                                        <div className="w-[75%] mb-2">
                                            <div className="flex gap-2 font-semibold text-black pb-4">
                                                <p className="whitespace-nowrap">RN Sign/Orders Noted</p>
                                                {SurgeryFormData['rn_signature'] && (
                                                    <>
                                                        <p className="font-roboto text-base text-black whitespace-nowrap">
                                                            {SurgeryFormData.rnSignedDate}
                                                        </p>
                                                        <p className="font-roboto text-base text-black whitespace-nowrap">
                                                            {SurgeryFormData.rnSignedTime}
                                                        </p>
                                                    </>
                                                )}
                                            </div>

                                            <SignatureField
                                                fieldName="rn_signature"
                                                label=""
                                                formData={SurgeryFormData}
                                                isEditing={isEditing}
                                                isDisabled={isNext}
                                                signatures={signatures}
                                                canvasRefs={canvasRefs}
                                                invalidFields={invalidFields}
                                                updateSignatureData={updateSignatureData}
                                                clearSignature={clearSignature}
                                                toggleEditMode={toggleEditMode}
                                                isNext={surgeryUpload}
                                            />
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    )
                }
            </form>
            <div className="flex justify-end">
                {[0, 1, 2, 3].includes(currentPage) ? renderNextButton() : renderSurgeryUploadButton()}

            </div>
        </>
    );
};

export default Emerald;
